/* eslint-disable */
import React, { Fragment, useEffect } from "react";
import { Field } from 'formik';
import ErrorMessage from "../ErrorMessage"
import {
    Label,
    Input
  } from "reactstrap"
  import InputMask from "react-input-mask"

const TextInput = (props) => {
    const {
        field,
        form: {setFieldValue, errors, isSubmitting, isValidating},
        label, 
        labelCustomClass, 
        placeholder, 
        type, 
        disabled, 
        readOnly, 
        externalLabel,
        name, 
        onChange,
        inputCustomClass,
        staticInput,
        staticInputText,
        staticInputCustomClass,
        inputStyle,
        inputSize,
        icon,
        iconLeft,
        leftIconDivider,
        rightIconDivider,
        isRequired,
        isAlphabetOnly,
        onBlur,
        restrictPaste,
        restrictSpace,
        zipCode,
        inputMasked,
        inputFormat,
        restrictCopy,
        restrictAlphabets
    } = props;
    

    const keys = Object.keys(errors);
    const ObjectType = keys && (typeof errors[keys[0]] === 'object')
    const data = keys && errors[keys[0]] && ObjectType && Object.keys(errors[keys[0]])

    useEffect(() => {
      if (keys.length > 0 && isSubmitting && !isValidating) {
        const selector = ObjectType ? `${keys[0]}.${data[0]}` : `${keys[0]}`;
        if (selector === `${field.name}`) {
          document.querySelector(`[name="${field.name}"]`) && document.querySelector(`[name="${field.name}"]`).focus()
        }
      }
    })

    const handleOnKeyPress = (event) => {
      const k = event.charCode;
      if(isAlphabetOnly) {
        if(!((event.charCode >= 65 && event.charCode < 91) || (event.charCode >= 97 && event.charCode < 123)))
        event.preventDefault();
        }
        if(restrictSpace){
          if(event.charCode === 32)  event.preventDefault();
        }
        if(zipCode && (!((k > 64 && k < 91) || (k > 96 && k < 123) || k == 8 || k == 32 || (k >= 48 && k <= 57)))){
          event.preventDefault();
        }
        if(restrictAlphabets){
          if(((event.charCode >= 65 && event.charCode < 91) || (event.charCode >= 97 && event.charCode < 123)))
          event.preventDefault();
        }
        
    }

    return (
        <Fragment>
        <Label for={externalLabel} className={`${labelCustomClass} `}>{label}{isRequired && (<span className="text-danger font-medium-3 lh-1">&#42;</span>)}</Label>
        {staticInput && (
        <p className={`${staticInputCustomClass} form-control-static`} id="StaticInput">
         {staticInputText}
        </p>
        )} 
        {!staticInput && (
         <div className={`position-relative ${iconLeft ? 'has-icon-left' : ''} ${rightIconDivider &&'input-divider-right'} ${leftIconDivider && 'input-divider-left'}`}>
       {!inputMasked ? (
        <Input 
        {...field}
        type={type}
        min="0"
        onKeyPress={(event) => 
         handleOnKeyPress(event)
        }
        onCut={(e) => {
          if(restrictCopy){
          e.preventDefault();
          return false;
        }
        }}
        onCopy={(e) => {
          if(restrictCopy){
            e.preventDefault();
            return false;
          }
        }}
        onBlur={onBlur}
        // autoComplete="off"
        onChange={e => { setFieldValue(field.name, e.target.value); if (onChange) onChange(e.target.value); }}
         value={(field.value === 0 ? field.value : (field.value || ''))}
        className={`${inputCustomClass} ${inputStyle} `} 
        disabled ={disabled} 
        id={name} 
        readOnly={readOnly} 
        placeholder={placeholder ? placeholder : label}
        onPaste={(event) => restrictPaste && event.preventDefault()}
        />
        ) :(
          <InputMask
          mask={inputFormat ? inputFormat :"(999) 999-9999"}
        {...field}
        type={type}
        min="0"
        onKeyPress={(event) => 
         handleOnKeyPress(event)
        }
        onBlur={onBlur}
        onChange={e => { setFieldValue(field.name, e.target.value); if (onChange) onChange(e.target.value); }}
         value={(field.value === 0 ? field.value : (field.value || ''))}
        className={`${inputCustomClass} ${inputStyle} form-control `} 
        disabled ={disabled} 
        id={name} 
        readOnly={readOnly} 
        placeholder={placeholder ? placeholder : label}
        onPaste={(event) => restrictPaste && event.preventDefault()}
      />
        )}
        {icon && (
        <div className="form-control-position cursor-pointer">
         {icon}
        </div>
        )}
        </div>
        )}
    </Fragment>
    )
    }

const Textfield = (props) => {
    const {
      label,
      name,
      type,
      onBlur,
      leftIconDivider,
     labelCustomClass,
     placeholder,
     disabled,
     readOnly,
     onChange,
     externalLabel,
     inputCustomClass,
     staticInput,
     staticInputText,
     staticInputCustomClass,
     icon,
     rightIconDivider,
     iconLeft,
     inputStyle, // round , square
     inputSize, // sm , lg
    isRequired,
    isAlphabetOnly,
    restrictPaste,
    restrictSpace,
    zipCode,
    inputMasked,
    inputFormat,
    restrictCopy,
    restrictAlphabets
    } = props;
    return (
      <div className="w-100">
        <Field
          label={label}
          name={name}
          component={TextInput}
          onChange={onChange}
          type={type}
          isAlphabetOnly={isAlphabetOnly}
          onBlur={onBlur}
          disabled={disabled}
          labelCustomClass={labelCustomClass}
          readOnly={readOnly}
          placeholder={placeholder}
          externalLabel={externalLabel}
          inputCustomClass={inputCustomClass}
          staticInput={staticInput}
          staticInputText={staticInputText}
          staticInputCustomClass={staticInputCustomClass}
          inputStyle={inputStyle}
          inputSize={inputSize}
          icon={icon}
          leftIconDivider={leftIconDivider}
          rightIconDivider={rightIconDivider}
          iconLeft={iconLeft}
          isRequired={isRequired}
          restrictPaste={restrictPaste}
          restrictSpace={restrictSpace}
          zipCode={zipCode}
          inputMasked={inputMasked}
          inputFormat={inputFormat}
          restrictCopy={restrictCopy}
          restrictAlphabets={restrictAlphabets}
        />
        <ErrorMessage name={name} className="text-danger"/>
      </div>
    );
  };
  
  export default Textfield;